import { render } from "./SkyButtonLink.vue?vue&type=template&id=aec68450&scoped=true"
import script from "./SkyButtonLink.vue?vue&type=script&lang=js"
export * from "./SkyButtonLink.vue?vue&type=script&lang=js"

import "./SkyButtonLink.vue?vue&type=style&index=0&id=aec68450&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aec68450"]])

export default __exports__